var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9026_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37591 4.37479L5.31341 8.43729C5.06477 8.68594 4.92509 9.02316 4.92509 9.37479C4.92509 9.72643 5.06477 10.0637 5.31341 10.3123C5.56205 10.5609 5.89928 10.7006 6.25091 10.7006C6.60254 10.7006 6.93977 10.5609 7.18841 10.3123L11.2509 6.24979C11.7482 5.75251 12.0276 5.07806 12.0276 4.37479C12.0276 3.67153 11.7482 2.99708 11.2509 2.49979C10.7536 2.00251 10.0792 1.72314 9.37591 1.72314C8.67265 1.72314 7.99819 2.00251 7.50091 2.49979L3.43841 6.56229C2.69249 7.30822 2.27344 8.3199 2.27344 9.37479C2.27344 10.4297 2.69249 11.4414 3.43841 12.1873C4.18433 12.9332 5.19602 13.3523 6.25091 13.3523C7.30581 13.3523 8.31749 12.9332 9.06341 12.1873L13.1259 8.12479",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9026_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.18398aeb9e4b278b9e9f8ea82b1d9c31.svg";
export { ForwardRef as ReactComponent };